/***
 *
 *   DROPDOWN STYLES
 *   Ported from ui-reference/src/components/ui/dropdown-menu.tsx.
 *
 **********/

const Style = {
    dropdown: 'z-50 min-w-[10rem] overflow-hidden rounded-lg border bg-popover p-1 text-popover-foreground shadow-lg',
    item: `relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none
    transition-colors hover:bg-primary-50 focus:bg-primary-50 dark:hover:bg-primary-900/40 dark:focus:bg-primary-900/40`,
    itemDisabled: 'pointer-events-none opacity-50',
    label: 'px-2 py-1.5 text-xs font-semibold text-text-secondary',
    separator: '-mx-1 my-1 h-px bg-border',
    shortcut: 'ml-auto text-xs tracking-widest opacity-60',
    check: 'ml-auto shrink-0 text-primary-600',
};

export default Style;
